import { Dispatch } from "redux";
import { SortEnum } from "../../../common/enums/SortEnum";
import { setSort } from "../CertificateExpirySlice";

interface Props {
    dispatch: Dispatch;
    sort: {
        sortName: SortEnum;
        isSorted: boolean;
    };
}

export const handleCertificateExpirySort = (props: Props) => () => {
    const { dispatch, sort } = props;

    switch (sort.sortName) {
        case SortEnum.EMPLOYEE_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? SortEnum.EMPLOYEE_NAME_ASC
                        : SortEnum.EMPLOYEE_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case SortEnum.QUALIFICATION_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? SortEnum.QUALIFICATION_NAME_ASC
                        : SortEnum.QUALIFICATION_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case SortEnum.EDUCATOR_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? SortEnum.EDUCATOR_NAME_ASC
                        : SortEnum.EDUCATOR_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case SortEnum.EXPIRY_DATE_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? SortEnum.EXPIRY_DATE_ASC
                        : SortEnum.EXPIRY_DATE_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        default:
            break;
    }
};
